import { SiteHeader } from "@/components/site-header";
import { CargoProductsTable } from "./CargoProductsTable";

export default function CargoProductsPage() {
  return (
    <>
      <SiteHeader title="Productos" />
      <div className="flex flex-1 flex-col px-4 py-6 lg:px-6">
        <CargoProductsTable />
      </div>
    </>
  );
}
